const RAW_LANGUAGE_MAP = {
  EN: 'en',
  JA: 'ja',
  ZH_CN: 'zh_CN',
  ZH_TW: 'zh_TW',
  FR: 'fr',
} as const;

export const LANGUAGE_MAP = new Proxy(RAW_LANGUAGE_MAP, {
  // 当外部尝试 Object.keys()、Object.getOwnPropertyNames() 或 for...in 时触发
  ownKeys() {
    throw new Error(
      '❌ 禁止遍历 LANGUAGE_MAP！请直接通过属性精准获取值，如 LANGUAGE_MAP.EN',
    );
  },
});

export type LanguageType = (typeof LANGUAGE_MAP)[keyof typeof LANGUAGE_MAP];

// 系统界面支持的语言选项
export const SYSTEM_LANGUAGE_OPTION_LIST = [
  { value: LANGUAGE_MAP.EN, label: 'English' },
  { value: LANGUAGE_MAP.JA, label: 'Japanese' },
  { value: LANGUAGE_MAP.ZH_CN, label: '中文' },
] as const;

export type SystemLanguageType =
  (typeof SYSTEM_LANGUAGE_OPTION_LIST)[number]['value'];

// 后台 CMS 配置支持的语言选项
export const CMS_LANGUAGE_OPTION_LIST = [
  {
    value: 'all',
    label: 'ALL',
  },
  { value: LANGUAGE_MAP.EN, label: 'English' },
  { value: LANGUAGE_MAP.JA, label: 'Japanese' },
  { value: LANGUAGE_MAP.ZH_CN, label: '中文' },
  {
    value: LANGUAGE_MAP.ZH_TW,
    label: '繁体中文',
  },
];
